import {BasicButton} from "@goodgamestudios/asset-globals";
import {BasicCustomCursor, BasicModel, MathBase, TextFieldHelper, TextValide} from "@goodgamestudios/core";
import {
    classImplementsInterfaces,
    ExternalInterface,
    instanceOfClass,
    TextField,
    TextFieldType
} from "@goodgamestudios/createjs-utilities";
import {int} from "@goodgamestudios/math-utilities";
import {ErrorCodes} from "../../../constants/shared/ErrorCodes";
import {AvatarCreationEvent} from "../../../event/AvatarCreationEvent";
import {Poker2PreloadEvent} from "../../../event/Poker2PreloadEvent";
import {Poker2ShopData} from "../../../model/components/Poker2ShopData";
import {Poker2Model} from "../../../model/Poker2Model";
import {AvatarHelper} from "../../helper/AvatarHelper";
import {Poker2Dialog} from "../Poker2Dialog";
import {Poker2NameSelection} from "../Poker2NameSelection";

import {SFConstants} from "../../../constants/SFConstants";
import Container = createjs.Container;
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import TextEvent = createjs.TextEvent;
import Rectangle = createjs.Rectangle;

export class Poker2AvatarCreationDialogPreload extends Poker2Dialog {

    public static NAME: string = "Poker2AvatarCreationDialogPreload";

    private currentGender: string;
    private selectedButton: MovieClip;
    private myAvatarIndex: number = 0;
    private randomAvatars: any[] = [];

    private itemShop: Poker2ShopData;
    private nameSelectionToolTip: Poker2NameSelection;
    private isWaitingForServerMessage: boolean = false;
    private static GENDER_GIRL: string = "female";
    private static GENDER_BOY: string = "male";

    private static ERRORBUBBLE_WIDTH: number = 172;

    protected showBackground: boolean = true;
    protected backgroundAlpha: number = 0.3;

    constructor(disp: MovieClip) {
        super(disp);
        this.dispBounds = disp.getBounds(null);

        this.itemShop = Poker2Model.itemShop;
        //this.controller.addEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontLoadComplete));
        this.controller.addEventListener("socialAvatarCreationSuccessful", this.bindFunction(this.closeAvatarCreation));
        this.controller.addEventListener("socialavatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.addEventListener("socialRagisterFaild", this.bindFunction(this.onRegisterFailed));

        this.updateBackground();
        this.initGender();
        if (ExternalInterface.available) {
            try {
                ExternalInterface.call("setLanguage", this.env.currentCountryLanguageCode);
            }
            catch (error) {
            }
        }
        this.init();
    }

    /** TODO: hack to ensure starting with gender male preselected **/
    protected initGender(): void {
        // switch once to guarantee correct view
        this.updateGenderButtons(this.creationDialog.btn_female);
        this.updateGenderButtons(this.creationDialog.btn_male);

        // show actual currentGender
        this.updateGenderButtons((this.currentGender == Poker2AvatarCreationDialogPreload.GENDER_GIRL) ? this.creationDialog.btn_female : this.creationDialog.btn_male);
    }

    protected onBGAddedToStage(event: Event): void {
        this.bg.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onBGAddedToStage));
        this.bg.width = this.bg.stage.stageWidth;
        this.bg.height = this.bg.stage.stageHeight;
        this.bg.x = -this.disp.x;
        this.bg.y = -this.disp.y;
    }

    // private onFontLoadComplete(event: LanguageDataEvent): void {
    //     this.updateAllTextFields();
    //     this.init();
    //     this.hideNameSelection();
    // }

    // private updateAllTextFields(): void {
    //     var container: Container = this.disp as Container;
    //
    //     for (var textField of this.findTextFields(container))
    //         Poker2LanguageFontManagerPreload.getInstance().changeFontByLanguage(textField);
    // }

    /**
     * Search recursively for textfields
     */
    // private findTextFields(container: Container): any[] {
    //     var result: any[] = [];
    //
    //     for (var i: number = 0; i < container.numChildren; i++) {
    //         var disp: DisplayObject = container.getChildAt(i);
    //
    //         if (instanceOfClass(disp, "TextField"))
    //             result.push(disp);
    //         else if (instanceOfClass(disp, "Container")) {
    //             var childResult: any[] = this.findTextFields(disp as Container);
    //             result = result.concat(childResult);
    //         }
    //     }
    //     return result;
    // }

    /*override*/
    protected onCursorOver(event: MouseEvent): void {
        if (event.target instanceof BasicButton && event.target.enabled) {
            this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
        }

        if (event.target instanceof TextField) {
            if ((event.target as TextField).type == TextFieldType.INPUT) {
                this.layoutManager.customCursor.hideCustomCursor();
            }
        }
    }

    /*override*/
    protected onCursorOut(event: MouseEvent): void {
        if (event.target instanceof BasicButton) {
            this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
        }

        if (event.target instanceof TextField) {
            if (event.target.type == TextFieldType.INPUT) {
                this.layoutManager.customCursor.showCustomCursor();
            }
        }
    }

    /*override*/
    // protected onDispAddedToStage(event: Event): void {
    //     this.show();
    //     //this.tooltipManager = new Poker2ToolTipManagerPreload(this);
    //     //this.tooltipManager.toolTip = new Library.PokerInterface.TooltipPreload();
    // }

    /**
     * Dialog mittog platzieren
     */

    /*override*/
    protected updatePos(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = MathBase.min((this.disp.stage.stageHeight / 600), (this.disp.stage.stageWidth / 800));
            this.disp.x = -this.dispBounds.left - (this.dispBounds.width - Poker2AvatarCreationDialogPreload.ERRORBUBBLE_WIDTH) / 2 + (this.disp.stage.stageWidth) / 2;
            this.disp.y = -this.dispBounds.top - this.dispBounds.height / 2 + (600 * this.disp.scaleY) / 2;
        }
    }

    /*override*/
    public init(): void {
        //this.updateAllTextFields();

        this.creationDialog.changeTextFieldCacheScale(2);

        this.creationDialog.btn_female.toolTipText = BasicModel.languageData.getTextById("create_avatar_female");
        this.creationDialog.btn_male.toolTipText = BasicModel.languageData.getTextById("create_avatar_male");
        this.creationDialog.btn_random.toolTipText = BasicModel.languageData.getTextById("create_avatar_random");

        this.creationDialog.btn_play.minWidth = 100;
        this.creationDialog.btn_play.label = BasicModel.languageData.getTextById("generic_btn_continue");

        this.creationDialog.txt_title.text = BasicModel.languageData.getTextById("login_title");
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.creationDialog.txt_gender, BasicModel.languageData.getTextById("create_avatar_gender"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.creationDialog.txt_look, BasicModel.languageData.getTextById("create_avatar_look"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.creationDialog.txt_name, BasicModel.languageData.getTextById("create_avatar_name"));
        //			creationDialog.btn_login.visible = false;
        this.creationDialog.inputName.inputField.text = this.env.displayName.slice(0, this.env.maxUsernameLength);

        // if app runs within social network (env.loginIsKeyBased), take the given gender
        if (this.env.loginIsKeyBased) {
            this.currentGender = this.env.gender;
        }
        else {
            this.currentGender = Poker2AvatarCreationDialogPreload.GENDER_BOY;
        }

        this.generateRandomAvatars();
    }

    public show(): void {
        this.isWaitingForServerMessage = false;
        this.hideNameSelection();
        this.switchGender((this.currentGender == Poker2AvatarCreationDialogPreload.GENDER_GIRL) ? this.creationDialog.btn_female : this.creationDialog.btn_male);
    }

    /*override*/
    protected onClick(event: MouseEvent): void {
        if (this.isWaitingForServerMessage)
            return;

        switch (event.target) {
            case this.creationDialog.btn_random:
                this.myAvatarIndex = int((this.myAvatarIndex + 2) % this.randomAvatars.length);
                this.updateAvatar();
                break;
            case this.creationDialog.btn_play:
                this.onCreateAvatar();
                break;
            case this.creationDialog.btn_male:
            case this.creationDialog.btn_female:
                this.switchGender(event.target as MovieClip);
                break;
            case this.creationDialog.inputName.inputField:
                this.hideNameSelection();
                this.creationDialog.mc_errorbubble.visible = false;
                break;
        }
    }

    private generateRandomAvatars(): void {
        this.randomAvatars = AvatarHelper.generatePresetAvatars(this.itemShop);
        this.myAvatarIndex = int(MathBase.random(0, this.randomAvatars.length - 1));
    }

    private updateAvatar(): void {
        while (this.creationDialog.mc_holder.numChildren > 0)
            this.creationDialog.mc_holder.removeChildAt(0);

        var mcAvatar: Container = AvatarHelper.drawAvatarByItemArray(this.randomAvatars[this.myAvatarIndex], true);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = (155 / bounds.width);

        if ((180 / bounds.height) > scaleFactor)
            scaleFactor = (210 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = -(bounds.top * scaleFactor);

        this.creationDialog.mc_holder.addChild(mcAvatar);
    }

    private switchGender(button: MovieClip): void {
        this.currentGender = (button == this.creationDialog.btn_female) ? Poker2AvatarCreationDialogPreload.GENDER_GIRL : Poker2AvatarCreationDialogPreload.GENDER_BOY;
        // gerade ist female, ungerade male
        if ((this.currentGender == Poker2AvatarCreationDialogPreload.GENDER_BOY && (this.myAvatarIndex % 2) != 0) ||
            (this.currentGender == Poker2AvatarCreationDialogPreload.GENDER_GIRL && (this.myAvatarIndex % 2) == 0)) {
            this.myAvatarIndex = int((this.myAvatarIndex + 1) % this.randomAvatars.length);
        }

        this.updateGenderButtons(button);
        this.updateAvatar();
    }

    private updateGenderButtons(button: MovieClip): void {
        if (this.selectedButton != button) {
            if (this.selectedButton) this.selectedButton.deselected();

            this.selectedButton = button;
            this.selectedButton.selected();
        }
    }

    /**
     * AvatarDaten als Event an FrameOne weitergeben
     */
    private onCreateAvatar(): void {
        if (this.isWaitingForServerMessage)
            return;
        if (!TextValide.isSmartFoxValide(this.creationDialog.inputName.inputField.text)) {
            this.showErrorBubble(28);
            //TODO Infodialog erstellen
            //				layoutManager.showDialog( "Poker2WarningDialog",
            //					new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_title"), Poker2Model.languageData.getTextById("generic_register_namenotvalid")));
            return;
        }

        var avatarParams: string = this.avatarArrayToString(this.randomAvatars[this.myAvatarIndex]);
        //neu
        var avatarObject: any = {items: avatarParams, gender: this.currentGender};
        var paramsObject: any = {avatar: avatarObject, name: this.creationDialog.inputName.inputField.text};

        this.isWaitingForServerMessage = true;
        Poker2Model.smartfoxClient.sendMessage("cas", [JSON.stringify(paramsObject)]);
    }

    private avatarArrayToString(avatarParts: any[]): string {
        var result: string = "";
        if (avatarParts != null) {
            for (let entryList of avatarParts) {
                var voObject: any = entryList;
                if (voObject === undefined) continue;

                if (result.length > 0) result += "#";
                result += voObject.id + "+" + voObject.colorId;
            }
        }
        return result;
    }

    private onShowNameSuggestion(event: Poker2PreloadEvent): void {
        this.creationDialog.mc_errorbubble.visible = false;
        this.isWaitingForServerMessage = false;
        if (this.nameSelectionToolTip == null) {
            this.nameSelectionToolTip = new Poker2NameSelection(new Library.PokerInterface.AvatarNameSelection(), this.creationDialog.inputName);
            this.creationDialog.inputName.addChild(this.nameSelectionToolTip.disp);
            this.nameSelectionToolTip.disp.y = 5;
            this.nameSelectionToolTip.disp.x = 10;
        }
        this.nameSelectionToolTip.showNames(event.params[0]);
        this.nameSelectionToolTip.disp.addEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
        this.creationDialog.inputName.inputField.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onTextFieldChange));
    }

    private onTextFieldChange(): void {
        this.hideNameSelection();
    }

    private onNameSelected(event: AvatarCreationEvent): void {
        this.hideNameSelection();
        this.nameSelectionToolTip.disp.removeEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
        this.creationDialog.inputName.inputField.text = event.params.shift();
    }

    private hideNameSelection(): void {
        if (this.nameSelectionToolTip)
            this.nameSelectionToolTip.hide();
        this.creationDialog.mc_errorbubble.visible = false;
        this.creationDialog.inputName.inputField.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onTextFieldChange));
    }

    private onRegisterFailed(e: Poker2PreloadEvent): void {
        this.isWaitingForServerMessage = false;
        this.showErrorBubble(e.params[0]);
    }

    private showErrorBubble(error: number): void {
        switch (error) {
            case 28:
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.mc_errorbubble.txt_title, BasicModel.languageData.getTextById("generic_alert_watchout"));
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.mc_errorbubble.txt_copy, BasicModel.languageData.getTextById("alert_invalid_name"), 4);
                break;
            default:
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.mc_errorbubble.txt_title, BasicModel.languageData.getTextById("generic_alert_watchout"));
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.creationDialog.mc_errorbubble.txt_copy, BasicModel.languageData.getTextById("errorcode_" + error), 4);
                break;
        }
        this.creationDialog.mc_errorbubble.visible = true;
        this.creationDialog.inputName.inputField.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onTextFieldChange));
    }

    private closeAvatarCreation(): void {
        this.isWaitingForServerMessage = false;
        this.hideNameSelection();
        this.controller.removeEventListener("socialAvatarCreationSuccessful", this.bindFunction(this.closeAvatarCreation));
        //this.controller.removeEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontLoadComplete));
        this.controller.removeEventListener("socialavatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.removeEventListener("socialRagisterFaild", this.bindFunction(this.onRegisterFailed));
        this.hide();
        // if (this.disp)
        //     this.disp.removeChild(this.creationDialog);
    }

    // private avatarArrayToDictionary(avatarParts: any[]): Map<any, any> {
    //     var result: Map<any, any> = new Map<any, any>();
    //     if (avatarParts != null) {
    //         for (let entryList of avatarParts) {
    //             var voObject: any = entryList;
    //             if (voObject === undefined) continue;
    //             result.set(voObject.id, voObject);
    //         }
    //     }
    //     return result;
    // }

    // private get env(): IEnvironmentGlobals {
    //     return new Poker2EnvironmentGlobals;
    // }

    protected get creationDialog(): Library.PokerInterface.PokerAvatarCreationSocial {
        return this.disp as Library.PokerInterface.PokerAvatarCreationSocial;
    }
}

classImplementsInterfaces(Poker2AvatarCreationDialogPreload, "MovieClip");
